<template>
  <SectionCard title="Cancellation statements">
    <template #actions>
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary text-nowrap"
      >
        Download all · last 12 months
      </button>
      <button type="button" class="btn btn-sm btn-primary text-nowrap">
        Add new statement
      </button>
    </template>

    <p v-if="cancellations.length === 0" class="mb-0 text-body-secondary small">
      No cancellation has executed in this group for 2026. Statements appear
      here as registries return them.
    </p>
    <CancellationStatementsTable
      v-else
      :cancellations
      :companies="STATEMENT_COMPANIES"
      :isAdmin="false"
      :showCompanyColumn="false"
      @view-details="openDetails"
      @download-documents="() => undefined"
    />

    <CancellationDetailsModal
      v-if="selected"
      :cancellationId="selected.id"
      :company_id="selected.company_id"
      :is_admin="false"
      :preloadedStatement="selected"
      @close="selected = null"
    />
  </SectionCard>
</template>

<script setup lang="ts">
import {
  STATEMENT_COMPANIES,
  toCancellation,
  toCancellationStatement,
} from "@/compliance_groups/fixture/adapters";
import type { GroupKey } from "@/compliance_groups/fixture/complianceGroupsTypes";
import { useComplianceDemoStore } from "@/compliance_groups/useComplianceDemoStore";
import CancellationDetailsModal from "@/dashboard/invoice_management/CancellationDetailsModal.vue";
import CancellationStatementsTable from "@/dashboard/invoice_management/CancellationStatementsTable.vue";
import type { Cancellation, CancellationStatement } from "@/types/cancellation";
import { computed, ref } from "vue";
import SectionCard from "./SectionCard.vue";

// The Evidence tab reuses the production statements table and details modal with fixture rows.
// The header buttons are illustrative (no upload/download behind them in the demo).
const props = defineProps<{ group: GroupKey }>();

const store = useComplianceDemoStore();
const statements = computed(() => store.statementsFor(props.group));
const cancellations = computed<Cancellation[]>(() =>
  statements.value.map(toCancellation)
);
const selected = ref<CancellationStatement | null>(null);

const openDetails = (row: Cancellation) => {
  const index = cancellations.value.findIndex((c) => c.id === row.id);
  selected.value =
    index >= 0 ? toCancellationStatement(statements.value[index], index) : null;
};
</script>
